import { z } from "zod";
import { EventIdParamSchema } from "./common";

/** Staff assignment on an event (joined with master staff profile). */
export const EventStaffAssignmentSchema = z.object({
  id: z.string(),
  eventId: z.string(),
  staffId: z.string(),
  displayName: z.string(),
  defaultRoleLabel: z.string().nullable(),
  roleLabel: z.string().nullable(),
  bankName: z.string().nullable(),
  bankAccount: z.string().nullable(),
  accountName: z.string().nullable(),
  notes: z.string().nullable(),
  sortOrder: z.number(),
  isActive: z.boolean(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});
export type EventStaffAssignmentDTO = z.infer<typeof EventStaffAssignmentSchema>;

/** @deprecated alias */
export type EventStaffDTO = EventStaffAssignmentDTO;

export const AssignEventStaffSchema = z.object({
  staffId: z.string().min(1),
  roleLabel: z.string().trim().optional(),
  notes: z.string().trim().optional(),
  sortOrder: z.number().int().optional(),
});
export type AssignEventStaffDTO = z.infer<typeof AssignEventStaffSchema>;

export const UpdateEventStaffAssignmentSchema = z.object({
  roleLabel: z.string().trim().nullable().optional(),
  notes: z.string().trim().nullable().optional(),
  sortOrder: z.number().int().optional(),
  isActive: z.boolean().optional(),
});
export type UpdateEventStaffAssignmentDTO = z.infer<
  typeof UpdateEventStaffAssignmentSchema
>;

export const EventStaffParamSchema = EventIdParamSchema.extend({
  /** Assignment row id (legacy param name in routes). */
  staffId: z.string().min(1),
});
export type EventStaffParamDTO = z.infer<typeof EventStaffParamSchema>;

export const ListEventStaffQuerySchema = z.object({
  activeOnly: z
    .enum(["true", "false"])
    .optional()
    .transform((v) => v === "true"),
});
export type ListEventStaffQueryDTO = z.infer<typeof ListEventStaffQuerySchema>;
